import { useQuery } from '@grandvisionhq/graphql';
import { toPreferredStore } from '../mappers/profile.js';
import GET_PREFERRED_STORE_ID from '../operations/queries/get-preferred-store-id.js';

const usePreferredStore = ()=>{
    var ref;
    const { data , loading , error , refetch  } = useQuery(GET_PREFERRED_STORE_ID);
    return {
        data: (data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.preferredStore) ? toPreferredStore(data.me.preferredStore) : null,
        loading,
        error,
        refetch
    };
};

export { usePreferredStore };
//# sourceMappingURL=use-preferred-store.js.map
